import { Box, Center, Grid, GridItem, Text } from "@chakra-ui/react";
import React, { useState } from "react";
import { Loader } from "../../components/Loader";
import { Container } from "../../components/Text/styles";
import { Title } from "../../components/Title";
import { INotifyAllFormValues, NotifyAllForm } from "../../forms";
import { useNotifyAllMutation } from "../../graphql";

const SendNotification: React.FC = () => {
  const [notifyAll, { data, loading }] = useNotifyAllMutation();

  const onSubmitSend = (data: INotifyAllFormValues) => {
    const ok = window.confirm(
      "Ju po u dërgoni njofim të gjithë klientëve. Jeni të sigurtë?"
    );

    if (ok) {
      notifyAll({
        variables: {
          body: data.body,
          language: data.languageCode,
          role: data.role,
          title: data.title,
          externalURL: data.externalURL,
        },
      });
    }
  };

  const notifications = data?.notifyAll;

  return (
    <>
      <Container>
        <Grid templateColumns="repeat(6, 1fr)" gap={4}>
          <GridItem
            colSpan={4}
            paddingRight={0}
            height="calc(100vh - 80px)"
            overflow="scroll"
          >
            <Box borderWidth="1px" borderRadius="lg" background="#FFF" p="10px">
              <Title title="Njofto të gjithë klientët"></Title>
              <NotifyAllForm onSubmit={onSubmitSend} />

              {!loading ? null : (
                <Center m={5}>
                  <Text>Duke dërguar njoftimet. Ju lutem prisni!</Text>
                </Center>
              )}

              {notifications ? (
                <Center m={5}>
                  <Text>
                    U dërguan {notifications.devices} mesazhe në{" "}
                    {notifications.accounts} llogari.
                  </Text>
                </Center>
              ) : null}
            </Box>
          </GridItem>
          <GridItem colStart={5} colEnd={7}></GridItem>
        </Grid>
      </Container>
    </>
  );
};

export default SendNotification;
